import { render, staticRenderFns } from "./LegalLayout.vue?vue&type=template&id=7c4dae56"
import script from "./LegalLayout.vue?vue&type=script&lang=ts"
export * from "./LegalLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports